
import * as THREE from "three"


export default class Picture {

    /**
     *
     * @param texture
     * @param width
     * @param height
     * @returns {Picture}
     */
    constructor( texture , width , height , textureMask = null ) {

        // get width height

        this.geometry = new THREE.PlaneGeometry( width, height, 1, 1 )

        texture.wrapS = THREE.RepeatWrapping
        texture.wrapT = THREE.RepeatWrapping
        //texture.repeat.set(1,-1)

        //let textureMask = new THREE.TextureLoader().load('')

        this.material = new THREE.MeshBasicMaterial({
            map: texture,
            alphaMap: textureMask,
            side: THREE.DoubleSide,
            transparent: true,
         //   alphaTest: 1,

        })

        this.mesh = new THREE.Mesh(
            this.geometry,
            this.material
        )

        //return this

    }

    setMaterial( texture ) {

        this.material.map = texture

    }

    /**
     * modify texture
     * @param texture
     */
    modifyTexture( texture ) {

        // @todo
        this.mesh.material.map = texture
        //this.mesh.material.map.needsUpdate = true
        //this.mesh.material.needsUpdate = true

    }

    setImage( uri ) {

        let texture = new THREE.TextureLoader().load( uri );

        this.material.map = texture

    }

    getMesh() {

        return this.mesh

    }

}